import { render } from "./TermsV20260905.vue?vue&type=template&id=a8c6b2be&scoped=true"
const script = {}

import "./TermsV20260905.vue?vue&type=style&index=0&id=a8c6b2be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c6b2be"]])

export default __exports__